import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType';

export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwo = {
  content?: string;
  /** 트윗 유형 */
  tweetType?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType;
};
